import { useState } from 'react';

export function useDebounce(func: Function, delay: number) {
    const [timeout, updateTimeout] = useState<NodeJS.Timeout | null>(null);

    return function (...args: any[]) {
        if (timeout) {
            clearTimeout(timeout);
        }

        updateTimeout(setTimeout(() => func(...args), delay));
    };
}
